import { yupResolver } from '@hookform/resolvers/yup';
import { type Resolver } from 'react-hook-form';
import * as yup from 'yup';

import ERROR_MESSAGE from '@/constants/errors.constants';
import { REGEX_NUMBER } from '@/constants/regex';
import { type Evento } from '@/interfaces/model/eventos.interface';
import { type ILookup } from '@/interfaces/model/generic.interface';

export type ILookupCheckbox = ILookup & {
	value: Array<'true'>;
};

export type NotificacionTramiteForm = {
	tipoTramite: ILookupCheckbox;
	listaTipoNotificacion: ILookupCheckbox[];
};

export type IUserForm = {
	nombre: string;
	apellido1: string;
	apellido2?: string;
	email: string;
	telefono: string;
	username: string;
	id: number;
	rol: string;
	serviciosNotificaciones: NotificacionTramiteForm[];
	envioNotificacionMail: string[];
	activo: string[];
	nombreEmisor: string;
	nifEmisor: string;
	eventos: Evento[];
};

export const defaultValues = {
	nombre: '',
	apellido1: '',
	apellido2: '',
	email: '',
	telefono: '',
	username: '',
	rol: '',
	listaTiposNotificacionTramite: [],
	envioNotificacionMail: [],
	activo: [],
};

const COMPATIBLE_REGEX = /^[a-zA-ZÀ-ÿ'-]+([\s'-][a-zA-ZÀ-ÿ'-]+)*$/;

export const schema = yup.object().shape({
	username: yup.string().required(ERROR_MESSAGE.required),
	nombre: yup
		.string()
		.required(ERROR_MESSAGE.required)
		.matches(COMPATIBLE_REGEX, 'El nombre contiene caracteres no válidos.'),
	apellido1: yup
		.string()
		.required(ERROR_MESSAGE.required)
		.matches(COMPATIBLE_REGEX, 'El nombre contiene caracteres no válidos.'),
	apellido2: yup
		.string()
		.nullable()
		.notRequired()
		.transform((value) => (value === '' ? null : value))
		.test('regex-optional', 'El nombre contiene caracteres no válidos.', (value) => {
			if (!value) return true;
			return COMPATIBLE_REGEX.test(value);
		}),
	rol: yup.string().required(ERROR_MESSAGE.required),
	email: yup.string().email(ERROR_MESSAGE.emailNoValido).required(ERROR_MESSAGE.required),
	telefono: yup
		.string()
		.required(ERROR_MESSAGE.required)
		.max(9, 'Tamaño máximo 9 caracteres.')
		.min(9, 'Tamaño mínimo 9 caracteres.')
		.test('telefono-no-valido', ERROR_MESSAGE.telefonoNoValido, (value) => REGEX_NUMBER.test(value ?? '')),
});

export const resolver = (): Resolver<any, string> => yupResolver(schema);
